import { StyleProp, View, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Label from "../../../components/Label";
import { TransactionDetailsStatus } from "../types";

type Props = TransactionDetailsStatus & {
  style?: StyleProp<ViewStyle>;
};

export default function StatusLabel({ text, completed, error, style }: Props) {
  const { colors } = useTheme();

  const backgroundColor = error
    ? colors.errorContainer
    : completed
    ? colors.surfaceVariant
    : colors.tertiaryContainer;

  const textColor = error
    ? colors.onErrorContainer
    : completed
    ? colors.onSurfaceVariant
    : colors.onTertiaryContainer;

  const prefix = completed === true ? "● " : completed === false ? "○ " : "";
  const label = `${prefix}${text}`;

  return (
    <Label
      name={label}
      style={style}
      textColor={textColor}
      backgroundColor={backgroundColor}
    />
  );
}

export function StatusLabels({
  statuses,
}: {
  statuses: TransactionDetailsStatus[];
}) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row")}>
      {statuses.map((status, index) => (
        <StatusLabel
          {...status}
          key={index}
          style={!!index && tailwind("ml-1")}
        />
      ))}
    </View>
  );
}
